import { render } from "./FileUploadModal.vue?vue&type=template&id=043fa668"
import script from "./FileUploadModal.vue?vue&type=script&lang=js"
export * from "./FileUploadModal.vue?vue&type=script&lang=js"
script.render = render

export default script